import { isDefined } from './misc';

export const concatClasses = (
    ...classes: Array<string | boolean | Array<string | boolean>>
): string =>
    (Array.isArray(classes[0]) && classes.length === 1 ? classes[0] : classes)
        .filter(Boolean)
        .join(' ');

/**
 * Load an image by `src` via `HTMLImageElement`.
 * For scenarios that you want to display an image of the same `src` with `<img>` later.
 */
export function loadImage({
    src,
    srcSet,
    sizes,
    loading,
    crossOrigin,
    referrerPolicy,
}: {
    crossOrigin?: HTMLImageElement['crossOrigin'];
    loading?: HTMLImageElement['loading'];
    referrerPolicy?: HTMLImageElement['referrerPolicy'];
    sizes?: HTMLImageElement['sizes'];
    src: HTMLImageElement['src'];
    srcSet?: HTMLImageElement['srcset'];
}) {
    return new Promise<HTMLImageElement>((resolve, reject) => {
        const img = new Image();

        if (isDefined(crossOrigin)) img.crossOrigin = crossOrigin;

        if (isDefined(referrerPolicy)) img.referrerPolicy = referrerPolicy;

        if (isDefined(sizes)) img.sizes = sizes;

        if (isDefined(loading)) img.loading = loading;

        if (isDefined(srcSet)) img.srcset = srcSet;

        img.src = src || '';

        if (img.complete) {
            resolve(img);
        } else {
            img.addEventListener('load', onLoad);
            img.addEventListener('error', onError);
        }

        function onLoad() {
            resolve(img);
            dispose();
        }

        function onError(event: ErrorEvent) {
            reject(event);
            dispose();
        }

        function dispose() {
            img.removeEventListener('load', onLoad);
            img.removeEventListener('error', onError);
        }
    });
}

export function checkEventTargetIsOutsideContent(el: Node, contentEl: Node): boolean {
    if (el === contentEl) return false;

    if (el.parentElement) return checkEventTargetIsOutsideContent(el.parentElement, contentEl);

    return true;
}

export const getCurrentWindow = (): Window => window;
